import "./ProjectCard.css";
import { Link } from "react-router-dom";
import { FaSteam } from "react-icons/fa6";
import { BiLogoSteam } from "react-icons/bi";
function ProjectCard(props) {
  const isDisabled = props.projectData.projectPage === "-";
  const Wrapper = isDisabled ? "div" : Link;
  return (
    <Wrapper
      to={!isDisabled ? props.projectData.projectPage : undefined}
      className={`card border border-dark h-100 c-card ripple ${
        isDisabled ? "disabled" : ""
      }`}
      style={{ cursor: isDisabled ? "default" : "pointer" }}
    >
      <div
        className="card-header text-center c-header"
        style={{ textTransform: "Uppercase" }}
      >
        {props.projectData.title}
      </div>
      <div className="bg-image c-image  " data-mdb-ripple-color="light">
        <img
          src={props.projectData.cardImgUrl}
          alt=""
          className="card-img h-100"
          style={{ minHeight: "100%", height: "100%" }}
        />
      </div>
      <p className="card-text c-genre">{props.projectData.genreDesc}</p>
      <div className="card-body">
        <p className="card-text">{props.projectData.shortDesc}</p>
          {props.projectData.steamURL && props.projectData.steamURL !== "-" && (
        <button
          className="btn btn-dark btn-sm ms-2"
          onClick={(e) => {
            e.stopPropagation(); // prevent triggering the Link
            window.open(props.projectData.steamURL, "_blank", "noopener,noreferrer");
          }}
        >
          <BiLogoSteam size={25} />
        </button>
      )}
      </div>
      <div className="card-footer">
        <p className="text-bold text-center">
          {props.projectData.roles.map((role, index) => {
            const spacer =
              props.projectData.roles.length - 1 !== index ? ` / ` : ``;
            return role + spacer;
          })}
        </p>
      </div>
    </Wrapper>
  );
}

export default ProjectCard;
